export class ConstantClass {
  static readonly County = 'county';
  static readonly City = 'city';
}

export enum TabIndexes {
  County = 0,
  City = 1,
}
